import { t } from "../../../services/utils";
import BaseStoryViewModel from "./BaseStoryViewModel";
import LineView from "../components/LineView";
import mealTypes from "../../../constants/meal-types";
import Divider from "../components/Divider";
import RecordView from "../components/RecordView";
import MealDetailView from "../components/MealDetailView";
import CheckinDetailView from "../components/CheckinDetailView";
class CheckinStoryViewModel extends BaseStoryViewModel {
  constructor(story, me, viewType) {
    super(story, me, viewType);
  }
  getStoryDate = () => {
    return this.story.story.cd;
  };
  addContentViewModel = (parts, handler) => {
    let checkinData = this.story.story;
    parts.push({
      type: CheckinDetailView,
      props: {
        checkinData: checkinData,
      },
      key: `checkin-${this.story.story_id}`,
    });
    parts[parts.length - 1].props.paddingBottom = 10;
  };
}
export default CheckinStoryViewModel;
